// Entra-only login screen. There is no longer a password form — all auth
// goes through Azure App Service Easy Auth. The button kicks off the OAuth
// redirect; Easy Auth handles the rest and lands the user back at '/'.

export default function Login() {
  function handleSignIn() {
    const returnTo = encodeURIComponent('/');
    window.location.href = `/.auth/login/aad?post_login_redirect_url=${returnTo}`;
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>Time Tracker</h1>
        <p style={{ fontSize: 13, color: '#737370', marginBottom: 20 }}>
          Sign in with your Microsoft work account.
        </p>
        <button
          className="btn-primary"
          style={{ width: '100%', justifyContent: 'center', padding: '10px' }}
          onClick={handleSignIn}
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
